
import { Component, Vue, Prop, Watch, Mixins } from "vue-property-decorator"
import ValidatorMixin from "@/shared/mixins/validator/ValidatorMixin"
import EInput from './Input.vue'

const CPF_MASK = '###.###.###-##'
// CNPJ alfanumérico: raiz e ordem aceitam [A-Z0-9] (token `X` do Quasar, que já
// converte para maiúsculas), enquanto os dois dígitos verificadores continuam
// numéricos. O CNPJ numérico antigo continua sendo aceito por esta máscara.
const CNPJ_MASK = 'XX.XXX.XXX/XXXX-##'
const NO_MASK = 'XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'

// Letras do CNPJ alfanumérico são sempre maiúsculas. Normalizamos para que a API
// receba a forma canônica mesmo quando o valor vem pré-preenchido em minúsculas.
const canonicalize = (value: string, country: string) => (country === 'BR' ? value.toUpperCase() : value)

@Component({
  components: {
    EInput
  },
})
export default class TaxIdInput extends Mixins(ValidatorMixin) {
  @Prop() readonly country!: string
  @Prop() readonly value!: string
  @Prop() readonly rules!: Function[]

  private input = canonicalize(this.value ?? '', this.country)
  private type = this.country === 'BR' ? (!this.input || this.input.length <= 11 ? 'CPF' : 'CNPJ') : ''

  get mask() {
    return this.country === 'BR' ? (this.type === 'CPF' ? CPF_MASK : CNPJ_MASK) : NO_MASK
  }

  get placeholder() {
    if (this.country !== 'BR') {
      return this.$t('message.taxIdPlaceholder')
    }

    return this.type === 'CPF' ? this.$t('message.cpfPlaceholder') : this.$t('message.cnpjPlaceholder')
  }

  validateTaxId(val: string) {
    if (this.country === 'BR') {
      if (this.type === 'CPF') return this.cpf(val)
      return this.cnpj(val)
    }

    return true
  }

  onInputChanged(val: string) {
    this.$emit('input', canonicalize(val, this.country))
  }

  @Watch('type')
  onTypeChanged(val: string) {
    if (val && this.input) {
      this.validateFields()
    }
  }
}
